// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index__wrapper__wZckm","desktopWrapper":"index__desktopWrapper__1TOs-","itemInfo":"index__itemInfo__2V0cc","itemTitle":"index__itemTitle__3sgWs"};